import React, { ReactNode } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
	snackbarOpen: boolean;
	snackbarMessage: string;
	onClose: () => void;
}

const htmlRegex = new RegExp("(<.*?>.*?</.*?>)");

export function AccountSnackBar(props: Props){
	const { snackbarOpen, snackbarMessage } = props;
    const messageNodes:ReactNode[] = snackbarMessage.split(htmlRegex).map(item => 
        item.startsWith('<') ? <a href='https://www.sermoncentral.com/contactus?ref=UnknownError' style={{ color: "#2196f3"}}>customer service</a>  : item);

	return (
		<Snackbar
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			open={snackbarOpen}
			onClose={props.onClose}
			ContentProps={{
				"aria-describedby": "message-id",
			}}
			message={<span id="message-id"><React.Fragment children={messageNodes}/></span>}
			action={[
				<span key="0" style={{ marginTop: "5px" }}>
					<IconButton key="close" aria-label="Close" color="inherit" onClick={props.onClose}>
						<CloseIcon />
					</IconButton>
				</span>,
			]}
		/>
	);
};